import React from "react";
import _ from "lodash";

const ChipSelector = (props) => {
  const handleSelection = (value) => {
    if (!props.required && props.selected && props.selected == value) {
      props.setSelected("");
    } else {
      props.setSelected(value);
    }
  };

  const renderChips = () => {
    return _.map(props.items, (item, index) => {
      return (
        <div
          key={index}
          className={props.selected == item.value ? "chip chip--selected" : "chip"}
          onClick={() => {
            handleSelection(item.value);
          }}
        >
          {item.label}
        </div>
      );
    });
  };

  return renderChips();
};

export default ChipSelector;
